import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

// Ensure the root element exists
const rootElement = document.getElementById('root');
if (!rootElement) {
  const root = document.createElement('div');
  root.id = 'root';
  document.body.appendChild(root);
}

// Create root element
const root = createRoot(document.getElementById('root')!);

// Render the app
root.render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);

// Add snapshot data for crawlers
if (window.location.pathname === '/blog' || window.location.pathname === '/about') {
  const snapshotData = document.createElement('script');
  snapshotData.type = 'application/ld+json';
  snapshotData.textContent = JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: document.title,
    description: document.querySelector('meta[name="description"]')?.getAttribute('content'),
    url: window.location.href,
  });
  document.head.appendChild(snapshotData);
}